import { useState } from 'react'
import Plan from 'components/Plan'
import MainButton from 'components/Buttons/MainButton'
import { IoArrowForwardOutline } from 'react-icons/io5'
import { SubContainer } from '../styles'

export default function PlansForm ({
  plans = [],
  subscriptionData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [selectedPlan, setSelectedPlan] = useState ({})

  const handleSubmit = () => {
    handleFormSubmitted ({ plan: selectedPlan })
  }

  return (
    <SubContainer>
      {plans.map (plan => (
        <Plan
          key={plan.id}
          data={plan}
          discount={subscriptionData.discount}
          selected={selectedPlan.id === plan.id}
          onClick={() => setSelectedPlan (plan)}
        />
      ))}
      {selectedPlan.id && (
        <MainButton
          onClick={handleSubmit}
          aria-label='Próximo'
          leftIcon={<IoArrowForwardOutline size={20} color='#000000'/>}
          style={{width: 55}}
        />
      )}
    </SubContainer>
  )
}
